import React, { useState } from "react";
import useProperties from "hooks/useProperties";
import RemoveWarningDialog from "components/Dialog/RemoveWarningDialog";
import SearchResultPropertyCard from "./SearchCard/components/SearchResultPropertyCard";
import { usePropertyActions } from "hooks/usePropertyActions";
import { useNavigate } from "react-router";

const SearchResultCard = ({
  property,
  lastPropertyRef,
  isOrganisePage = false,
  isMapProperty = false,
}) => {
  const { removeDiscardedProperty } = useProperties();
  const { setIsDiscardedProperty } = usePropertyActions(property);
  const [removeWarningPopupOpen, setRemoveWarningPopupOpen] = useState(false);
  const navigation = useNavigate();

  // Function to save the scroll position of the research container
  const saveScrollPosition = () => {
    const scrollableContainer = document.getElementById(
      "research-scrollable-container"
    );
    if (scrollableContainer) {
      sessionStorage.setItem(
        "researchScrollPosition",
        scrollableContainer.scrollTop
      );
    }
  };

  // Navigate to property details page
  const navigateToPropertyDetails = () => {
    saveScrollPosition();
    // Clear the returning flag when navigating to details
    sessionStorage.removeItem("returningFromDetails");
    navigation(
      `/property/${property?._id}?average_gross_yield=${property?.average_gross_yield}`
    );
  };

  // Remove discarded property
  const handleDeleteDiscardedProperty = async () => {
    try {
      setIsDiscardedProperty(false);
      setRemoveWarningPopupOpen(false);
      await removeDiscardedProperty(property._id);
    } catch (error) {
      setIsDiscardedProperty(true);
    }
  };

  return (
    <>
      <div
        onClick={navigateToPropertyDetails}
        ref={lastPropertyRef}
        className=""
      >
        <SearchResultPropertyCard
          property={property}
          isOrganisePage={isOrganisePage}
        />
      </div>

      <RemoveWarningDialog
        warningText={`Vuoi rimuovere questa proprietà dalla lista delle proprietà scartate?`}
        isOpen={removeWarningPopupOpen}
        isClose={() => setRemoveWarningPopupOpen(false)}
        onClick={handleDeleteDiscardedProperty}
        buttonText2="Annulla"
      />
    </>
  );
};

export default SearchResultCard;
